import { createFileRoute } from '@tanstack/react-router'
import { StrategyEvaluation } from '@/features/strategy-eval'

export const Route = createFileRoute(
  '/_authenticated/scoring/$conversationId/evaluate'
)({
  component: StrategyEvaluation,
})
